import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronDownMedium"><Path d="M18.1464 9.14645C18.3417 8.95118 18.6582 8.95118 18.8535 9.14645C19.0487 9.34171 19.0487 9.65822 18.8535 9.85348L12.3535 16.3535C12.1582 16.5487 11.8417 16.5487 11.6464 16.3535L5.14645 9.85348C4.95118 9.65822 4.95118 9.34171 5.14645 9.14645C5.34171 8.95118 5.65822 8.95118 5.85348 9.14645L12 15.2929L18.1464 9.14645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownMedium;
